import React from "react";
import Modal from "components/BaseWidgets/modal";
import coinBox from "assets/images/svg/refer-coin-box.svg";
import "./style.scss";
import Button from "components/BaseWidgets/button";
import Input from "components/BaseWidgets/form/input";


function ReferralModal({
  open,
  onCancel,
  closeIcon,
  className,
  wrapClassName,
  title,
  description,
  width,
  type,
  handleRefer,
  referralCode,
  setReferralCode,
}) {
 


  const handleReferClick = () => {
    if (referralCode.trim()) {
      handleRefer(referralCode);
    }
  };

  const renderContent = () => {
    if (type === "invite") {
      return (
        <div className="invite-content flex flex-col items-center gap-6">
          <div className="code-input-wrapper flex flex-col items-center gap-2">
            <label className="input-label font-body-md fw-400">
              Enter your code
            </label>
            <Input
              id="dotted"
              placeholder="CODE"
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value)}
              variant="dotted"
            />
          </div>
          <div className="flex flex-col items-center gap-4">
            <p className="description-secondary font-body-normal">
              Don’t have a code? No worries! Just continue and start exploring.
            </p>
            <Button
              className="continue-btn"
              size="md"
              onClick={handleReferClick}
            >
              Continue
            </Button>
          </div>
        </div>
      );
    }

    if (type === "refer") {
      return (
        <div className="refer-content">
          <p>Refer a friend and earn rewards! 💰</p>
          <p>Share your referral code now.</p>
        </div>
      );
    }

    return null;
  };

  return (
    <Modal
      isOpen={open}
      className={`referral-modal ${className}`}
      onCancel={onCancel}
      title=""
      width={width}
      footer={null}
      closable
      closeIcon={closeIcon}
      wrapClassName={wrapClassName}
    >
      <div className="modal-content">
        <span className="coin-box-icon">
          <img src={coinBox} alt="coin-box" />
        </span>
        <div className="heading-frame flex flex-col">
          <span className="content-title font-title-normal">{title}</span>
          <p className="content-description font-body-normal">{description}</p>
        </div>
        <div className="content">{renderContent()}</div>
      </div>
    </Modal>
  );
}

export default ReferralModal;
